import React from "react";
import { DashboardLoader } from "../../../../../components/Common/CommonButton";

/** Horizontal row of mini stat badges */
const StatBadgeRow = ({ items, loading }) => (
  <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", marginBottom: "14px" }}>
    {items.map((s, i) => (
      <div key={i} className="sad-stat-badge" style={{ borderBottom: `3px solid ${s.color}` }}>
        <div className="sad-stat-badge-label">{s.label}</div>
        <div className="sad-stat-badge-value" style={{ color: s.color }}>
          {loading ? <DashboardLoader /> : s.value}
        </div>
      </div>
    ))}
  </div>
);

export default StatBadgeRow;
